import { useQuery } from "react-query";
import { getPostHistoryReq } from "components/task-status/lib/data";

export const usePostHistory = (wipKey) => {
    return useQuery({
        queryKey: ["postHistory", wipKey],
        queryFn: () => getPostHistoryReq(wipKey),
    });
};
